//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import CFooter from "@/common/Footer"
export default{
  data(){
    return{
      showA: '-1',
      productList:[
        {
          title: '免费使用，只限阿贝云产品使用',
          subTil: ' 基于云计算的虚拟主机服务',
          content: '阿贝云推出独创的免备案服务供用户无偿使用，但是仅可以 用在阿贝云产品上。',
        },
        {
          title: '建议对域名备案',
          subTil: '极速稳定高弹性的计算服务',
          content: '使用的是海外线路，但由于国家防火墙的原因在稳定性和速 度方面不如国内主机，建议您把域名备案后使用国内线路。',
        },
        {
          title: '实时在线添加，永久免费',
          subTil: '提供五星级的域名注册服务',
          content: '在免备案服务中，选择您开通的产品，在线实时添加域名， 系统将给出免备案的解析地址。',
        },
        {
          title: '阿贝云虚拟主机、云服务器均可使用',
          subTil: '国内免费空间第一品牌',
          content: '无论是阿贝云的免费产品，还是收费产品，均可使用免备案服务。支持虚拟主机和云服务器。',
        },
      ]
    }
  },
  components: {
    CFooter
  },
  methods:{
    listDown(d) {
      if(this.showA == d) {
        this.showA = '-1'
      } else {
        this.showA = d
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/user/freebeian.vue